import React from "react";
import { Link } from "react-router-dom";
import defaultValues from "@/constant/defaultValues";
import moment from "moment";
import { publicRoutePaths } from "@/routes/public.routes.config";
import { buildPath } from "@/utils/common";

export default function BlogCard({ blog_detail }) {

  const { BASE_URL } = defaultValues.IMAGE_PATH;

  return (
    <div className='blog-card'>
      <Link to={`${buildPath(publicRoutePaths.BLOG_DETAIL, { blog_title: blog_detail.slug })}`} target="blank" href={`${buildPath(publicRoutePaths.BLOG_DETAIL, { blog_title: blog_detail.slug })}`} title={`${blog_detail.title}`}>
        <div className='img-wrape'>
          <img src={`${BASE_URL}${blog_detail.image}`} alt="" />
        </div>
      </Link>

      <div className='detail-wrape'>
        <Link to={`${buildPath(publicRoutePaths.BLOG_DETAIL, { blog_title: blog_detail.slug })}`} target="blank" href={`${buildPath(publicRoutePaths.BLOG_DETAIL, { blog_title: blog_detail.slug })}`} title={`${blog_detail.title}`}>
          <h2 title={blog_detail.title}>{blog_detail.title}</h2>
        </Link>


        <ul className='info-pad'>
          <li>
            <i className='calendar'></i>
            {moment(blog_detail.blog_publish_date).format('LL')}
          </li>
          {/* <li>
            <i className='user'></i>
            Admin
          </li> */}
          <li className="category">{blog_detail.category && blog_detail.category.category_name}</li>
        </ul>
        <p>{blog_detail.content}</p>
        <Link to={`${buildPath(publicRoutePaths.BLOG_DETAIL, { blog_title: blog_detail.slug })}`} target="blank" href={`${buildPath(publicRoutePaths.BLOG_DETAIL, { blog_title: blog_detail.slug })}`} title={`${blog_detail.title}`} className='btn outline'>
          Continue Reading
          <span className="round">
            <i className="sprite"></i>
          </span>
        </Link>
      </div>
    </div>
  )
}
